import { useCallback } from 'react';

import { useGenericSend } from '../useGenericSend';
import * as Types from './types';

export const useValidateLoginSession = () => {
    const send = useGenericSend();

    return useCallback(async (request: Types.IValidateLoginSessionRequestData = {}):
    Promise<Types.IValidateLoginSessionResponseData> => {
        const { data } = await send<Types.IValidateLoginSessionRequestData, Types.IValidateLoginSessionResponseData>({
            ID: 31178,
            description: 'Validate login session',
            responses: [31179, 31180],
            errorLevel: 1,
            ...request
        });

        return data;
    }, [
        send
    ]);
};
